import React from "react";

export const SkippedIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
    <path
      fill="currentColor"
      d="M152 765c10 0 18-7 21-16 41-157 157-262 290-262 48-4 94 13 128 47l-98 97c-6 6-8 16-4 24 3 8 11 13 19 13h365c12 0 22-10 22-22V281c0-9-5-17-13-20s-17-1-24 5l-96 96c-68-63-158-99-252-100-166 6-311 117-361 276-21 68-27 138-18 208 1 10 9 18 19 19h2zm359-460c88 0 174 38 235 102 4 4 10 7 15 7 6 0 12-2 16-6l75-76v293H560l75-75c8-8 8-20 2-29-43-54-109-83-176-76-118 0-225 72-288 188 3-28 9-55 17-82 44-142 173-241 321-246z"
    />
  </svg>
);
